// 图表组件配置（远期房态及通用图表设置）

import { UNIFIED_TOOLTIP_STYLE, tooltipLine } from '../../../configs/tooltipCommon';

function getWeekdayLabel(dateStr: string): string {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T12:00:00');
  const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  return weekdays[d.getDay()];
}

function formatTooltipDateHeader(axisValue: string): string {
  if (!axisValue) return '';
  const s = String(axisValue).trim();
  const year = new Date().getFullYear();
  const mSlashD = /^(\d{1,2})\/(\d{1,2})$/.exec(s);
  if (mSlashD) {
    const month = Number.parseInt(mSlashD[1], 10);
    const day = Number.parseInt(mSlashD[2], 10);
    const d = new Date(year, month - 1, day);
    const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return `${month}月${day}日${weekdays[d.getDay()]}`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const d = new Date(s + 'T12:00:00');
    const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return `${d.getMonth() + 1}月${d.getDate()}日${weekdays[d.getDay()]}`;
  }
  if (/^\d{1,2}月$/.test(s)) return s;
  return s;
}

export const COMMON_CHART_SETTINGS = {
  grid: { left: 60, right: 68, top: 24, bottom: 0 },
  barWidth: 24,
  barCategoryGap: '30%',
  barGap: '20%',
  tooltip: {
    ...UNIFIED_TOOLTIP_STYLE,
    position: function (point: number[], params: any, dom: HTMLElement, rect: any, size: any) {
      if (!rect) return [point[0] + 10, point[1] - 120];
      const tooltipHeight = size?.contentSize ? size.contentSize[1] : (dom ? dom.offsetHeight : 100);
      const tooltipWidth = size?.contentSize ? size.contentSize[0] : (dom ? dom.offsetWidth : 150);
      let y = point[1] - 40;
      let x = point[0] + 10;
      if (x + tooltipWidth > rect.x + rect.width) x = point[0] - tooltipWidth - 10;
      if (x < rect.x) x = rect.x + 10;
      let finalY = y;
      if (y < rect.y) finalY = rect.y + 10;
      else if (y + tooltipHeight > rect.y + rect.height) finalY = rect.y + rect.height - tooltipHeight - 10;
      return [x, finalY];
    },
    formatter: (params: any) => {
      if (Array.isArray(params)) {
        const dateValue = params[0]?.axisValue || '';
        const firstLine = formatTooltipDateHeader(String(dateValue)) || `${dateValue}${getWeekdayLabel(String(dateValue)) ? ` ${getWeekdayLabel(String(dateValue))}` : ''}`;
        let result = `${firstLine}<br/>`;
        const roomItems: { name: string; value: number | string; unit: string; color?: string }[] = [];
        const priceItems: { name?: string; value?: number | string; unit?: string; color?: string; lowest?: number; highest?: number }[] = [];
        params.forEach((item: any) => {
          const color = item.color;
          if (item.seriesType === "candlestick" && Array.isArray(item.value)) {
            const [, , lowest, highest] = item.value;
            priceItems.push({ color, lowest, highest });
          } else if (item.axisId === "left") {
            roomItems.push({ name: item.seriesName ?? '', value: item.value, unit: item.unit || "间", color });
          } else {
            priceItems.push({ name: item.seriesName, value: item.value, unit: item.unit || "", color });
          }
        });
        roomItems.forEach((item) => { result += tooltipLine(item.color, `${item.name}: ${item.value} ${item.unit}`); });
        priceItems.forEach((item) => {
          if (item.lowest !== undefined && item.highest !== undefined) {
            result += tooltipLine(item.color, `最低价: ${item.lowest} 元`);
            result += tooltipLine(item.color, `最高价: ${item.highest} 元`);
          } else {
            result += tooltipLine(item.color, `${item.name ?? ''}: ${item.value ?? ''} ${item.unit ?? ''}`);
          }
        });
        return result;
      } else {
        const param = params;
        const dateValue = param?.axisValue || '';
        const firstLine = formatTooltipDateHeader(String(dateValue)) || `${dateValue}${getWeekdayLabel(String(dateValue)) ? ` ${getWeekdayLabel(String(dateValue))}` : ''}`;
        const head = `${firstLine}<br/>`;
        const color = param?.color;
        if (param.seriesType === "candlestick" && Array.isArray(param.value)) {
          const [, , lowest, highest] = param.value;
          return head + tooltipLine(color, `${param.seriesName}<br/>最低价: ${lowest} 元<br/>最高价: ${highest} 元`);
        }
        return head + tooltipLine(color, `${param.seriesName}: ${param.value} ${param.unit || ""}`);
      }
    },
  },
} as const;

export const MINI_CHART_SETTINGS = {
  grid: { left: 0, right: 0, top: 0, bottom: 0 },
  xAxis: { show: false },
  yAxis: { show: false },
} as const;
